import { useRef } from 'react';

import { ServiceFeeCalculateResponse } from '../../../../server/views/serviceFees/serviceFees.types';

export type UseServiceFeeNoticeArgs = {
  enquiryId: string | number | null | undefined;
  isServiceFeeEnabled?: boolean;
  serviceFee: ServiceFeeCalculateResponse | null;
  soldForFigure: number | null;
  vrm: string;
};

export const useServiceFeeNotice = ({
  enquiryId,
  isServiceFeeEnabled,
  serviceFee,
  soldForFigure,
  vrm,
}: UseServiceFeeNoticeArgs): { feeAmountGBP?: number } => {
  const feeMismatchLogged = useRef(false);
  const feeMissingLogged = useRef(false);

  if (!isServiceFeeEnabled) {
    return {};
  }

  if (serviceFee == null) {
    if (soldForFigure != null && !feeMissingLogged.current) {
      feeMissingLogged.current = true;
      globalThis?.Sentry?.captureException(
        new Error('service fee missing'),
        {
          extra: { enquiryId, vrm },
          level: 'info',
          tags: {
            domain: 'service_fee',
          },
        },
      );
    }
    return {};
  }

  const { feeAmountGBP, price } = serviceFee;

  if (!feeMismatchLogged.current && price !== soldForFigure) {
    feeMismatchLogged.current = true;
    globalThis?.Sentry?.captureException(
      new Error('service fee price mismatch'),
      {
        extra: {
          enquiryId,
          feeAmountGBP,
          feeSourcePrice: price,
          soldForFigure,
          vrm,
        },
        level: 'info',
        tags: {
          domain: 'service_fee',
        },
      },

    );
  }

  return {
    feeAmountGBP,
  };
};
